import { useEditor } from '@grapesjs/react';
import { Box, Menu, TextField } from '@mui/material';
import { RiSettings3Line } from '@remixicon/react';
import { useRef, useState } from 'react';
import { AgButton } from 'src/components/ui';
import { cx } from '../../components/common';
import TopbarButtons from '../../components/TopbarButtons';

export default function PalletTagEditorSettings({ setTagSettings, tagSettings }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const editor = useEditor();

  return (
    <div className={cx('gjs-top-sidebar flex items-center p-1')}>
      <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => setOpen(true)} ref={ref}>
        <RiSettings3Line size={20} />
      </AgButton>

      <Menu open={open} onClose={() => setOpen(false)} anchorEl={ref.current}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
          <TextField
            label="Width (in)"
            size="small"
            type="number"
            value={tagSettings.width}
            onChange={(e) => {
              setTagSettings({ ...tagSettings, width: e.target.value });
              editor.runCommand('update-layout', { ...tagSettings, width: e.target.value });
            }}
          />
          <TextField
            label="Height (in)"
            size="small"
            type="number"
            value={tagSettings.height}
            onChange={(e) => {
              setTagSettings({ ...tagSettings, height: e.target.value });

              editor.runCommand('update-layout', { ...tagSettings, height: e.target.value });
            }}
          />
          <TextField
            label="Padding"
            size="small"
            type="number"
            value={tagSettings.padding}
            onChange={(e) => {
              setTagSettings({ ...tagSettings, padding: e.target.value });

              editor.runCommand('update-layout', { ...tagSettings, padding: e.target.value });
            }}
          />
        </Box>
      </Menu>

      <TopbarButtons className="ml-auto px-2" />
    </div>
  );
}
